import { render, staticRenderFns } from "./PlanCardAiRequests.vue?vue&type=template&id=3f734092&scoped=true"
import script from "./PlanCardAiRequests.vue?vue&type=script&lang=js"
export * from "./PlanCardAiRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f734092",
  null
  
)

export default component.exports